import { client } from "./generated/client.gen";

let tokenGetter: (() => Promise<string | null>) | null = null;

export function setTokenGetter(getter: (() => Promise<string | null>) | null) {
  tokenGetter = getter;
}

client.setConfig({
  baseUrl: import.meta.env.VITE_FASTAPI_URL as string,
});

client.interceptors.request.use(async (request) => {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
  }
  return request;
});
